import React from "react";
import { useFormContext } from "react-hook-form";
import {
  BagFill,
  BasketFill,
  GeoAltFill,
  PostcardFill,
  TelephoneFill,
} from "react-bootstrap-icons";
import { Row, Col } from "react-bootstrap";
import { NumberInput, TextInput } from "ui";

export const Business = () => {
  const { register } = useFormContext();
  return (
    <>
      <Row>
        <Col md={6} sm={12}>
          <TextInput
            icon={<BasketFill />}
            registration={register("business_name")}
            placeholder={"نام کسب و کار خود را وارد کنید"}
            label={"نام کسب و کار :"}
          />
        </Col>
        <Col md={6} sm={12}>
          <TextInput
            icon={<BagFill />}
            registration={register("activity")}
            placeholder={"نوع حوزه فعالیت خود را وارد کنید"}
            label={"نوع حوزه فعالیت :"}
          />
        </Col>
      </Row>
      <Row className="my-3">
        <Col md={6} sm={12}>
          <TextInput
            registration={register("city")}
            placeholder={"استان خود را وارد کنید"}
            label={" استان :"}
            icon={<GeoAltFill />}
          />
        </Col>
        <Col md={6} sm={12}>
          <TextInput
            registration={register("township")}
            placeholder={"شهرستان خود را وارد کنید"}
            label={"شهرستان :"}
            icon={<GeoAltFill />}
          />
        </Col>
      </Row>
      <Row className="my-3">
        <Col md={6} sm={12}>
          <NumberInput
            registration={register("landline_phonenumber")}
            placeholder={"    شماره تلفن ثابت را وارد کنید"}
            label={"تلفن ثابت :"}
            icon={<TelephoneFill />}
          />
        </Col>
        <Col md={6} sm={12}>
          <NumberInput
            registration={register("postal_code")}
            placeholder={"کد پستی خود را وارد کنید"}
            label={"کد پستی :"}
            icon={<PostcardFill />}
          />
        </Col>
      </Row>
      <Row className="my-3">
        <Col md={6} sm={12}>
          <TextInput
            registration={register("business_address")}
            placeholder={"تهران، خیابان ولیعصر ..."}
            label={"آدرس :"}
            icon={<GeoAltFill />}
          />
        </Col>
      </Row>
    </>
  );
};
